import Control from "ol/control/Control";
import { transform, toLonLat } from "ol/proj";

export class LatLongControl extends Control {
  constructor(view, opt_options) {
    const options = opt_options || {};
    const element = document.createElement("ul");
    super({
      element: element,
      target: options.target,
    });
    const this_ = this;
    element.className = "lat-long-input ol-unselectable";

    const latLongInput = document.createElement("input");
    element.appendChild(latLongInput);

    const swapBtn = document.createElement("button");
    swapBtn.type = "button";
    swapBtn.className = "swap-coords-btn";
    swapBtn.textContent = "⇄";
    swapBtn.title = "Swap coordinate order and recenter";
    swapBtn.addEventListener("click", () => {
      const val = latLongInput.value;
      const match = val.match(
        /^\s*(-?\d*(?:\.\d+)?)\s*([,\s])\s*(-?\d*(?:\.\d+)?)\s*$/,
      );
      if (!match) return;
      const sep = match[2] === "," ? ", " : " ";
      const newLat = Number(match[3]);
      const newLon = Number(match[1]);
      latLongInput.value = match[3] + sep + match[1];
      if (Number.isFinite(newLat) && Number.isFinite(newLon)) {
        view.setCenter(transform([newLon, newLat], "EPSG:4326", "EPSG:3857"));
      }
    });
    element.appendChild(swapBtn);

    const cajBtn = document.createElement("button");
    cajBtn.type = "button";
    cajBtn.className = "caj-nav-btn";
    cajBtn.style.marginLeft = "auto";
    cajBtn.textContent = "CaJ";
    cajBtn.title = "Open this view in the CaJ editor";
    cajBtn.addEventListener("click", () => {
      const center = view.getCenter();
      const zoom = view.getZoom();
      if (!center || zoom == null) return;
      const [lon, lat] = toLonLat(center);
      const params = new URLSearchParams();
      params.set("center", `${lon.toFixed(6)},${lat.toFixed(6)}`);
      params.set("zoom", zoom.toFixed(4));
      // APIM serves /caj-editor from the caj-editor.html blob; the Parcel
      // dev server doesn't do that stripping, so fall back to the extension
      // locally.
      const path =
        window.location.hostname === "localhost"
          ? "caj-editor.html"
          : "/caj-editor";
      window.location.href = `${path}?${params.toString()}`;
    });
    element.appendChild(cajBtn);

    const vertexBtn = document.createElement("button");
    vertexBtn.type = "button";
    vertexBtn.className = "caj-nav-btn";
    vertexBtn.textContent = "Vertex";
    vertexBtn.title = "Open this view in Vertex";
    vertexBtn.addEventListener("click", () => {
      const center = view.getCenter();
      const zoom = view.getZoom();
      if (!center || zoom == null) return;
      const [lon, lat] = toLonLat(center);
      window.open(
        `https://orbis.vertex.tomtom.com/#map=${zoom.toFixed(2)}/${lat.toFixed(6)}/${lon.toFixed(6)}`,
        "_blank",
        "noopener,noreferrer",
      );
    });
    element.appendChild(vertexBtn);

    const ndsBtn = document.createElement("button");
    ndsBtn.type = "button";
    ndsBtn.className = "caj-nav-btn";
    ndsBtn.textContent = "NDS";
    ndsBtn.title = "Open this view in NDS.live viewer";
    ndsBtn.addEventListener("click", () => {
      const center = view.getCenter();
      const zoom = view.getZoom();
      if (!center || zoom == null) return;
      const [lon, lat] = toLonLat(center);
      // Calibrated from two data points: zoom 10→alt 185697, zoom 19→alt 226
      const alt = Math.round(Math.exp(19.59 - 0.746 * zoom));
      const params = new URLSearchParams();
      params.set("lon", lon.toFixed(6));
      params.set("lat", lat.toFixed(6));
      params.set("alt", alt);
      params.set("m2d", "1");
      window.open(
        `https://mapviewer.delivery-umd-acc.maps.az.tt3.com/?${params.toString()}`,
        "_blank",
        "noopener,noreferrer",
      );
    });
    element.appendChild(ndsBtn);

    latLongInput.addEventListener("keyup", function (event) {
      if (event.code === "Enter") {
        let pattern = new RegExp(
          "^\\s*-?\\d*(?:\\.\\d+)?\\s*([,\\s])\\s*-?\\d*(?:\\.\\d+)?\\s*$",
          "m",
        );
        let inputValue = latLongInput.value;
        if (pattern.test(inputValue)) {
          let delimiter = inputValue.match(pattern)[1];
          let [lat, ...long] = inputValue.trimStart().split(delimiter);
          let latLong = [lat, long.join("")].map(Number);
          view.setCenter(
            transform([latLong[1], latLong[0]], "EPSG:4326", "EPSG:3857"),
          );
          view.setZoom(20);
        } else {
          alert("Please enter latlong in format: lat, long");
          latLongInput.focus();
        }
      }
    });

    // listen to changes
    this.on("propertychange", () => {
      latLongInput.value = this_.get("latLong");
    });
  }
}
